import { NewNotificationProps } from './new-notification-modal-types';
import { InlineSvg } from 'components/svg';
import { FC } from 'react';

export const ModalHeader: FC<NewNotificationProps> = ({ onClose }) => {
  return (
    <div className="modal-header mb-0 pb-0">
      {/* begin::Modal title */}
      <h2 className="fw-bolder">Send Notification</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-employees-modal-action="close"
        onClick={() => onClose()}
        style={{ cursor: 'pointer' }}
      >
        <InlineSvg path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};
